module.exports = __webpack_public_path__ + "static/bri-2486c6ffb0cc737123aa8fa97d72ef09.png";